import { SimpleHandler } from 'app/types/handlers';
import { DrawPaneComponent } from './../../components/draw-pane/draw-pane.component';
import { ObjID } from 'app/model/id-manager';
import { Destructable } from './../../types/destructable';
import { IDRegistry } from './../id-registry';
import { IDKeyTypes, IDManager } from './../id-manager';
import { EventEmitter, Injectable } from '@angular/core';
import { RouteService, RouteContext, RouteInfo } from './route.service';

export type RoutesContext = Destructable & {
  idManager: IDManager;
  idRegistry: IDRegistry;
  drawPane?: DrawPaneComponent;
  onVertexSelection?: EventEmitter<ObjID>;
}

export type RouteID = number;
export type RouteTreeNode = {
  id: RouteID;
  index: number;
  name: string;
  hasChildren: boolean;
  children?: Array<RouteTreeNode>;
  parent?: RouteTreeNode;
  _visible?: boolean;
  expanded?: boolean;
}
export type RoutesChangeType = 'route-vis-changed' | 'route-selected' | 'route-change' | 'delete-selected' | 'delete-all' | 'route-added' | 'jump-to-route' | 'jump-to-feature' | 'feature-selected' | 'segment-selected' | 'vertex-selected' | 'gps-add' | 'gps-update';
export type RoutesChange = {
  change: RoutesChangeType;
  route: RouteID;
  feature?: ObjID;
  handled?: SimpleHandler;

}
@Injectable({
  providedIn: 'root'
})
export class RoutesService {
  public static instance: RoutesService;
  public static onChange = new EventEmitter<RoutesChange>();
  private context?: RoutesContext;

  private _routes: Array<RouteID> = [];
  public get routes(): Array<RouteID> {
    return this._routes;
  }

  public get hasContext(): boolean {
    if (!this.context) return false;
    if (!this.context.destroyed) return true;
    this.context = undefined;
    return false;
  }

  constructor(private routeSvc: RouteService) {
    RoutesService.instance = this;
  }
  AddRoute(routeInfo: RouteInfo, toRoute?: RouteID): RouteInfo {
    if (!this.context) throw new Error('context not set');
    this.context.idRegistry.RegisterObject(IDKeyTypes.Route, routeInfo);
    if (this.context.drawPane) {
      this.context.drawPane.AddRouteLayer(routeInfo);
    }
    if (!toRoute) {
      this._routes.push(routeInfo.id as RouteID);
      return routeInfo;
    }
    const route = this.routeSvc.GetRoute(toRoute);
    if (!!route) this.routeSvc.AddSubRoute(toRoute, routeInfo.id as RouteID);

    return routeInfo;
  }
  RemoveAll() {
    for (const route of this.routes) {
      this.RemoveRoute(route);
    }
  }
  RemoveRoute(routeID: RouteID) {
    if (!this.context) throw new Error('context not set');
    if (routeID === 0) throw new Error('Attempting to remove non removable route');
    const route = this.context.idRegistry.Get(routeID) as RouteInfo;
    if (!!route) {
      if (route.hasChildren && !!route.children) {
        for (const sub of route.children) {
          this.RemoveRoute(sub);
        }
        route.children = [];
      }
      if (!!route.parent) {
        const parent = this.context.idRegistry.Get(route.parent) as RouteInfo;
        if (!!parent && parent.hasChildren && parent.children) {
          const index = parent.children?.indexOf(routeID);
          if (index > -1) parent.children.splice(index, 1);
          parent.hasChildren = parent.children.length > 0;
        }

      }
      console.log(this._routes);
      console.log('unregistering', routeID);
      if (route.feature) {
        route.feature.Remove();
        route.feature = undefined;
      }
      this.context.idRegistry.UnRegisterID(routeID);
    }
    if (this.routes.indexOf(routeID) > -1) {
      console.log(this.routes.indexOf(routeID));
      this.routes.splice(this.routes.indexOf(routeID), 1);
    }
    console.log('routes', this.routes);
  }
  SetContext(context: RoutesContext) {
    this.context = context;
    this.context.onDestroy.subscribe(() => {
      this.context = undefined;
    });
    this.routeSvc.SetContext(context as RouteContext);
  }

  MakeNode(routeId: RouteID, index: number): RouteTreeNode {
    const route = this.routeSvc.GetRoute(routeId);
    if (!route) throw new Error('attempting to create a node for a non extant route');
    const node: RouteTreeNode = { id: Number(route.id), index: (index), name: route.name, hasChildren: (route.hasChildren === true) }
    node.children = [];
    return node;
  }
  GetTree(routeId?: RouteID): Array<RouteTreeNode> {
    const tree: Array<RouteTreeNode> = [];
    const src = !!routeId ? [routeId] : this._routes;

    let idx = 0;

    for (const id of src) {
      const route = this.routeSvc.GetRoute(id) as RouteInfo;
      route.index = idx;
      const node: RouteTreeNode = { id: Number(route.id), index: (idx), name: route.name, hasChildren: (route.hasChildren === true) }
      const nodeChildren: Array<RouteID> = !!route.children ? route.children : [];
      const children: Array<RouteTreeNode> = [];
      let subIdx = 0;
      for (const nodeChild of nodeChildren) {
        const subTree = this.GetTree(nodeChild);
        for (const sub of subTree) {
          sub.index = subIdx;
          const subRoute = this.routeSvc.GetRoute(sub.id);
          if (subRoute) subRoute.index = sub.index;
          subIdx++;
          children.push(sub);
          sub.parent = node;

        };

      }

      idx += 1;
      node.children = children;
      route.expanded = true;
      tree.push(node);
    }
    console.log(tree);
    return tree;
  }
  static Notify(change: RoutesChangeType, route: RouteID, feature?: ObjID, handled?: SimpleHandler) {
    RoutesService.onChange.emit({
      change: (change),
      feature: (feature),
      route: (route),
      handled: (handled)
    });
  }
  static selected: any;
  static SetSelection(selection: any) {
    RoutesService.selected = selection;
  }


}
